/**
 * Prefixo com o nome de quem enviou a mensagem.
 *
 * Formato: `*Nome do Usuário:*` seguido de quebra de linha. Os asteriscos são a
 * sintaxe de negrito do WhatsApp, então o nome chega destacado no aparelho do
 * contato.
 *
 * O mesmo formato é aplicado no servidor pela função Postgres
 * `public.dispatch_scheduled_messages` (mensagens agendadas manuais).
 */

/** Casa a linha de prefixo no início do texto (ex.: `*Luan Alves:*\n`). */
export const SENDER_PREFIX_PATTERN = /^\*[^\n*]+:\*\n/;

export function buildSenderPrefix(senderName: string): string {
  return `*${senderName.trim()}:*\n`;
}

/**
 * Prefixa o texto com o nome do remetente quando a conta tem a opção habilitada.
 * Devolve o texto original se a opção estiver desligada ou se não houver nome.
 */
export function applySenderPrefix(
  text: string,
  senderName: string | null | undefined,
  enabled: boolean | null | undefined
): string {
  if (!enabled) return text;

  const name = (senderName ?? "").trim();
  if (!name) return text;

  return `${buildSenderPrefix(name)}${text}`;
}

/** Remove a linha de prefixo, se existir. Útil para exibir/reaproveitar o texto puro. */
export function stripSenderPrefix(text: string | null | undefined): string {
  if (!text) return text ?? "";
  return text.replace(SENDER_PREFIX_PATTERN, "");
}
